import { useState } from "react"

export function useLocalStorage<T>(key: string, initialValue: T, processValue?: (json: string) => T) {
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === "undefined") {
      return initialValue
    }

    try {
      const item = window.localStorage.getItem(key)
      return item ? (processValue ? processValue(item) : JSON.parse(item)) : initialValue
    } catch (error) {
      console.error(error)
      return initialValue
    }
  })

  const persistValue = (value: T) => {
    try {
      const valToStore = value instanceof Function ? value(storedValue) : value
      setStoredValue(valToStore)
      if (typeof window !== "undefined") {
        window.localStorage.setItem(key, JSON.stringify(valToStore))
      }
    } catch (error) {
      console.error(error)
    }
  }

  return [storedValue, persistValue]
}
